var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"Reportes"}},[_c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('reporte-utilidades')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }